import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Displays role detail information (name + menu access badges).
 * Used inside the Detail modal on the role list page.
 */
const RoleDetailSection = ({ data }) => {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col gap-4 overflow-auto">
      <div className="flex flex-col gap-1">
        <p className="text-xs font-medium text-neutral-500">{t('role_name')}</p>
        <p className="text-sm font-normal text-neutral-900">
          {data?.role || '-'}
        </p>
      </div>

      <div className="flex flex-col gap-1">
        <p className="text-xs font-medium text-neutral-500">{t('access')}</p>
        <p className="text-sm font-normal text-neutral-900 flex flex-wrap gap-2">
          {data?.menus?.map((menu, i) => (
            <span
              className="inline-block px-2 py-1 rounded-full text-primary-500 bg-primary-50 text-xs font-medium text-nowrap"
              key={i}
            >
              {menu.name}
            </span>
          ))}
        </p>
      </div>
    </div>
  );
};

export default RoleDetailSection;
